import React from 'react';
import ViewBudgetSurrenderComponent from '../../components/BudgetSurrender/ViewBudgetSurrender';


export default function ViewBudgetSurrenderPage() {
    return (
        <div>
          {<ViewBudgetSurrenderComponent />}
        </div>
      )
}